import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Card, Alert, Container } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';

const Login = () => {
  const [credentials, setCredentials] = useState({
    crewID: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const loggedUser = await login(credentials);
      toast.success('¡Inicio de sesión exitoso!');
      // Normaliza el rol a minúsculas para evitar problemas con "Trabajador" vs "usuario"
      const role = String(loggedUser?.ROL || '').toLowerCase();
      if (role === 'admin') {
        navigate('/dashboard');
      } else {
        navigate('/gastos');
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Error al iniciar sesión');
      toast.error('Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Container>
        <Card className="login-card">
          <Card.Body>
            <Card.Title className="text-center mb-4">
              <h3>App Gastos</h3>
              <p className="text-muted">Iniciar Sesión</p>
            </Card.Title>

            {error && (
              <Alert variant="danger" dismissible onClose={() => setError('')}>
                {error}
              </Alert>
            )}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Crew ID</Form.Label>
                <Form.Control
                  type="text"
                  name="crewID"
                  value={credentials.crewID}
                  onChange={handleChange}
                  placeholder="Ingresa tu Crew ID"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Contraseña</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  value={credentials.password}
                  onChange={handleChange}
                  placeholder="Ingresa tu contraseña"
                  required
                />
              </Form.Group>

              <Button
                variant="primary"
                type="submit"
                className="w-100"
                disabled={loading}
              >
                {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
              </Button>
            </Form>

            <div className="text-center mt-3">
              <small className="text-muted">
                
              </small>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default Login; 